import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import PageLoader from '@/components/PageLoader';
import {
  useApplicationOpen,
  useApplicationSettings,
} from '@/context/ApplicationSettingsContext';
import type { ApplicationKey } from '@/lib/publicSettings';

/**
 * Başvuru formu rotası koruyucusu.
 *
 * İlgili programın başvuruları kapalıysa sayfa RENDER EDİLMEZ; kullanıcı o
 * programın bilgi sayfasına yönlendirilir. Böylece adres çubuğuna doğrudan
 * yazarak da forma girilemez.
 *
 * ÖNEMLİ — ayar gelene kadar BEKLENİR: `useApplicationOpen` yüklenme sırasında
 * "açık" varsayar (ağ hatasında formu kilitlememek için). Beklemeseydik kapalı
 * bir formda önce sayfa çizilir, ayar gelince yönlendirme yapılırdı; kullanıcı
 * bir an formu görürdü. `loading` bittikten sonra karar verilir.
 *
 * NOT: Bu bir GÜVENLİK katmanı değildir, yalnızca UX. Asıl kısıtlama backend'de
 * (isApplicationOpen) zorlanır — kapalı programa POST 403 + { closed: true }
 * ile reddedilir.
 */
const ApplicationRoute = ({
  program,
  redirectTo,
  children,
}: {
  program: ApplicationKey;
  /** Kapalıyken gidilecek bilgi sayfası. */
  redirectTo: string;
  children: ReactNode;
}) => {
  const { loading } = useApplicationSettings();
  const open = useApplicationOpen(program);

  if (loading) {
    // data-page-loading: IntroSplash perdeyi bu işaret kalkmadan kaldırmaz
    // (bkz. SiteLayout) — açılışta boş bir alan görünmesin.
    return <PageLoader />;
  }

  if (!open) return <Navigate to={redirectTo} replace />;

  return <>{children}</>;
};

export default ApplicationRoute;
